import { useRef } from 'preact/hooks'
import { FeedbackFieldRefType } from 'scripts/type'
import { SafeAreaRefType } from 'components/ui/SafeArea'
import { TextareaFieldRefType } from './Fields/TextareaField'

export default function useRefs() {
  const contentRef = useRef<HTMLDivElement>(null)
  const brandingRef = useRef<HTMLDivElement>(null)
  const textareaRef = useRef<TextareaFieldRefType>(null)
  const starFieldRef = useRef<FeedbackFieldRefType>(null)
  const submitLoadingRef = useRef(false)
  const safeAreaRef = useRef<SafeAreaRefType>(null)

  return {
    contentRef,
    brandingRef,
    starFieldRef,
    submitLoadingRef,
    textareaRef,
    safeAreaRef,
  }
}
